import { css, cx } from "@/styled-system/css";
function ifNullStringNull(value) {
  if (value == "null") {
    return null;
  }
  return value;
}
const INPUT_INSET_STROKE = "inset 0 0 0 {borderWidths.Input.default} var(--shadow-color)";
const INPUT_FOCUS_VISIBLE_SHADOW = "inset 0 0 0 {borderWidths.Input.default} {colors.blue.600}, {shadows.focus}";
const RIM_BLUE = "blue.600";
const RIM_INSET = {
  boxShadow: `${INPUT_INSET_STROKE} !`,
  boxShadowColor: `${RIM_BLUE} !`
};
const FOCUS_VISIBLE_RIM = {
  boxShadow: `${INPUT_FOCUS_VISIBLE_SHADOW} !`,
  boxShadowColor: `${RIM_BLUE} !`
};
const HOVER_RIM = RIM_INSET;
const propertyReportInputHoverRim = css({
  "&&:is(:hover, [data-hover]):not(:focus)": HOVER_RIM
});
const propertyReportInputIdleRim = css({
  boxShadowColor: "gray.300",
  "&&:is(:focus, :focus-visible)": {
    boxShadowColor: "blue.600 !"
  },
  "&&:is(:focus, :focus-visible):is(:hover, [data-hover])": {
    boxShadowColor: "blue.600 !"
  }
});
const propertyReportTextEntryBlockPadding = css({
  // Constellation `Input` may attach className to host wrapper in some render paths.
  // Apply to host AND nested control so computed style on real <input>/<textarea> is forced.
  "&, & input, & textarea": {
    boxSizing: "border-box",
    borderStyle: "solid !",
    borderWidth: "var(--border-widths-Input-default, 1px) !",
    // Use raw CSS vars so this survives every merge path (v10 css prop + host className + recipe atoms).
    paddingTop: "calc(var(--spacing-100, 8px) + var(--border-widths-Input-default, 1px)) !",
    paddingBottom: "calc(var(--spacing-100, 8px) + var(--border-widths-Input-default, 1px)) !",
    paddingBlockStart: "calc(var(--spacing-100, 8px) + var(--border-widths-Input-default, 1px)) !",
    paddingBlockEnd: "calc(var(--spacing-100, 8px) + var(--border-widths-Input-default, 1px)) !",
    paddingLeft: "var(--spacing-300, 16px) !",
    paddingRight: "var(--spacing-300, 16px) !",
    paddingInlineStart: "var(--spacing-300, 16px) !",
    paddingInlineEnd: "var(--spacing-300, 16px) !"
  }
});
const propertyReportSingleLineFieldSize = css({
  "&, & input": {
    boxSizing: "border-box",
    minHeight: "calc(var(--spacing-600, 32px) + var(--spacing-100, 8px) + var(--spacing-50, 4px)) !",
    height: "calc(var(--spacing-600, 32px) + var(--spacing-100, 8px) + var(--spacing-50, 4px)) !"
  }
});
cx(propertyReportTextEntryBlockPadding, propertyReportSingleLineFieldSize);
const propertyReportTextareaFieldSize = css({
  "&, & textarea": {
    boxSizing: "border-box",
    minHeight: "calc(2 * {spacing.600} + {spacing.400} + 4 * {spacing.100}) !",
    height: "calc(2 * {spacing.600} + {spacing.400} + 4 * {spacing.100}) !"
  }
});
cx(propertyReportTextEntryBlockPadding, propertyReportTextareaFieldSize);
function getPropertyReportFilledFieldSurfaceCss(error) {
  const textAndPlaceholder = {
    color: "text.neutral",
    _placeholder: {
      // Slightly darker than `Input.text.placeholder` for readability (aligns with prod).
      color: "gray.600"
    }
  };
  if (error) {
    return {
      ...textAndPlaceholder,
      backgroundColor: "Input.bg.error",
      _hover: {
        backgroundColor: "Input.bg.error"
      },
      _focus: {
        backgroundColor: "Input.bg.active",
        _hover: {
          backgroundColor: "Input.bg.active"
        }
      },
      _focusVisible: {
        backgroundColor: "Input.bg.active",
        _hover: {
          backgroundColor: "Input.bg.active"
        }
      }
    };
  }
  return {
    ...textAndPlaceholder,
    backgroundColor: "gray.50",
    // Inset-only hover rim when not focused; `&:hover` alone would also match on hover+focus.
    "&:is(:hover):not(:focus):not(:focus-visible)": {
      backgroundColor: "gray.50",
      ...RIM_INSET
    },
    _hover: {
      backgroundColor: "gray.50"
    },
    _focus: {
      backgroundColor: "Input.bg.active",
      ...FOCUS_VISIBLE_RIM,
      boxShadowColor: "blue.600 !",
      _hover: {
        backgroundColor: "Input.bg.active",
        ...FOCUS_VISIBLE_RIM,
        boxShadowColor: "blue.600 !"
      }
    },
    _focusVisible: {
      backgroundColor: "Input.bg.active",
      ...FOCUS_VISIBLE_RIM,
      boxShadowColor: "blue.600 !",
      _hover: {
        backgroundColor: "Input.bg.active",
        ...FOCUS_VISIBLE_RIM,
        boxShadowColor: "blue.600 !"
      }
    },
    _active: {
      ...FOCUS_VISIBLE_RIM
    }
  };
}
export {
  getPropertyReportFilledFieldSurfaceCss,
  ifNullStringNull,
  propertyReportInputHoverRim,
  propertyReportInputIdleRim
};
